import AsyncComponent from '../../component/asynccomponent/AsyncComponent';
import { RolesEnum, CompanyTypesEnum } from '../../utils/Enums';

const orderservice = AsyncComponent(() =>
  import('../../../pages/orderServices/form/index')
)

const index = AsyncComponent(() =>
  import('../../../pages/service-order/OrderServiceIndex')
)

const detail = AsyncComponent(() =>
  import('../../../pages/service-order/Detail')
)

const reportGrid = AsyncComponent(() =>
  import('../../../pages/reports/ReportGrid')
)

const report = AsyncComponent(() =>
  import('../../../pages/reports/Report') 
)

const printOutOS = AsyncComponent(() =>
  import('../../../pages/PrintOutOs/index')
)

export default [
  {
    path: '/orderservices',
    component: index,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor, CompanyTypesEnum.Hired]
  },
  {
    path: '/orderservice',
    component: orderservice,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  },
  {
    path: '/orderservice/:id',
    component: orderservice,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  },
  {
    path: '/reports',
    component: reportGrid,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  },
  {
    path: '/report',
    component: report,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  },
  {
    path: '/detail/:id',
    component: detail,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor, CompanyTypesEnum.Hired]
  },
  {
    path: '/orderServiceView/:id',
    component: printOutOS,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor, CompanyTypesEnum.Hired]
  },
]



// WEBPACK FOOTER //
// ./src/shared/infra/routes/OrderServiceRoutes.js